import type { ProgressWidgetSettings } from './progressWidgetSettingsSchema'
import type { Maybe } from '@/types'

const DEFAULT_FONT_COLOR = 'ffffff'
const DEFAULT_HIGHLIGHT_COLOR = '9ECB0A'
const DEFAULT_LIGHT_BACKGROUND = 'ffffffff'
const DEFAULT_FONT = 'Fira Sans'
const DEFAULT_FONT_WEIGHT = 700
const DEFAULT_FONT_SIZE = 16

export default function getDefaultValues(input?: Maybe<Partial<ProgressWidgetSettings>>): ProgressWidgetSettings {
  return {
    darkMode: input?.darkMode ?? true,
    display: input?.display ?? 'both',
    textAlign: input?.textAlign ?? 'center',
    progressColor: input?.progressColor ?? DEFAULT_HIGHLIGHT_COLOR,
    progressBackgroundColor: input?.progressBackgroundColor ?? DEFAULT_LIGHT_BACKGROUND,
    headlineFont: input?.headlineFont ?? DEFAULT_FONT,
    headlineFontWeight: input?.headlineFontWeight ?? DEFAULT_FONT_WEIGHT,
    headlineFontSize: input?.headlineFontSize ?? DEFAULT_FONT_SIZE,
    headlineFontColor: input?.headlineFontColor ?? DEFAULT_FONT_COLOR,
    headlineText: input?.headlineText ?? 'Fortschritt zum Ziel',
    dataFont: input?.dataFont ?? DEFAULT_FONT,
    dataFontWeight: input?.dataFontWeight ?? DEFAULT_FONT_WEIGHT,
    dataFontSize: input?.dataFontSize ?? DEFAULT_FONT_SIZE,
    dataFontColor: input?.dataFontColor ?? DEFAULT_FONT_COLOR,
  }
}
